<div class="agpr-portfolio-leftPanel">
    <div class="agpr-portfolio-leftPanel-header">
        {{'Core.navigation.advDiscover.portfolios' | localize}}
    </div>
    <div class="agpr-portfolio-leftPanel-details">
        {{'Discover.portfolios.hype.header' | localize}}
    </div>
    <div>
        {{'Discover.portfolios.type' | localize}}
    </div>
    <div class="agpr-portfolio-leftPanel-toggles">
        <span
            class="agpr-portfolio-leftPanel-toggles-item"
            [ngClass]="{'selected' : portfolioService.entityType === entityTypes.CONTACT}"
            (agprClickUnless)="portfolioService.entityType = entityTypes.CONTACT; parametersChanged()"
        >
            <span class="fa-regular fa-duotone fa-user" aria-hidden="true"></span>
            {{'Discover.universal.contacts' | localize }}
        </span>
        <span
            class="agpr-portfolio-leftPanel-toggles-item"
            [ngClass]="{'selected' : portfolioService.entityType === entityTypes.OUTLET}"
            (agprClickUnless)="portfolioService.entityType = entityTypes.OUTLET; parametersChanged()"
        >
            <span class="fa-kit-duotone fa-agpr-outlet agpr-portfolio-leftPanel-toggles-icon" aria-hidden="true"></span>
            {{'Discover.universal.outlets' | localize }}
        </span>
    </div>

    <agpr-dropdown
        [id]="'lhp_regionDropdown'"
        class="agpr-portfolio-leftPanel-regiondropdown"
        label="Discover.portfolios.region"
        [options]="portfolioService.regionOptions"
        [(ngModel)]="portfolioService.region"
        (ngModelChange)="parametersChanged()"
        [bindToValue]="true"
        [itemTemplate]="itemTemplate"
    >
    </agpr-dropdown>
    <ng-template #itemTemplate let-item>
        <div
            *ngIf="item"
            class="agpr-portfolio-leftPanel-regiondropdown-item"
        >
            <img [src]="item.flag" alt="" />
            <span> {{ item.label | localize }} </span>
        </div>
    </ng-template>
    <agpr-dropdown
        [id]="'lhp_categoryDropdown'"
        label="Discover.portfolios.category"
        [options]="portfolioService.categoryOptions"
        [(ngModel)]="portfolioService.category"
        (ngModelChange)="parametersChanged()"
        [bindToValue]="true"
    >
    </agpr-dropdown>

    <agpr-panel
        [toggleable]="false"
        [contentPadding]="false"
        header="Discover.targeting.rhp.tabs.listMemberships"
        *ngIf="portfolioService.category === portfolioCategories.LEADING_BY_SECTOR"
        class="agpr-portfolio-leftPanel-subcategory"
    >
        <div
            *ngFor="let item of portfolioService.sectorCategories"
            class="agpr-portfolio-leftPanel-subcategory-item"
            (agprClickUnless)="portfolioService.subCategory = item.value; parametersChanged()"
            [ngClass]="{'selected' : portfolioService.subCategory === item.value}"
        >
            <i [class]="item.icon"></i>
            <span>{{item.label | localize}}</span>
        </div>
    </agpr-panel>
    <agpr-panel
        [toggleable]="false"
        [contentPadding]="false"
        header="Discover.targeting.rhp.tabs.listMemberships"
        *ngIf="portfolioService.category === portfolioCategories.CULTURAL_NEWS_MEDIA"
        class="agpr-portfolio-leftPanel-subcategory"
    >
        <div
            class="agpr-portfolio-leftPanel-subcategory-item"
            *ngFor="let item of portfolioService.culturalCategories"
            (agprClickUnless)="portfolioService.subCategory = item.value; parametersChanged()"
            [ngClass]="{'selected' : portfolioService.subCategory === item.value}"
        >
            <i [class]="item.icon"></i>
            <span>{{item.label | localize}}</span>
        </div>
    </agpr-panel>
</div>
